var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import { createVolumePromotionLevels } from "../../classes/definitions/volumePromotionLevel/volumePromotionLevel";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import VolumePromotionLevelsList from "../../components/AdjustmentLevels/AdjustmentLevelsList/VolumePromotionLevelsList";
import AppRoutes from "../../config/appRoutes";
import appRoutes from "../../config/appRoutes";
import SlidesReduxProps from "../Slides/SlidesReduxProps";
var VolumePromotions = /** @class */ (function (_super) {
    __extends(VolumePromotions, _super);
    function VolumePromotions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.volumePromotionId = '';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getLevels = function () {
            _this.api.getLevelsForVolumePromotion(_this.volumePromotionId)
                .then(function (response) {
                var adjustmentLevels = createVolumePromotionLevels(response.data);
                _this.setState({ data: adjustmentLevels });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка.', _this.props.history);
            });
        };
        _this.deleteItem = function (id) {
            _this.api.deleteLevelFromVolumePromotion(_this.volumePromotionId, id)
                .then(function () { return _this.getLevels(); });
        };
        _this.editItem = function (id) {
            _this.props.history.push(AppRoutes.volumePromotion.path + "/" + _this.volumePromotionId + appRoutes.volumePromotionLevel.path + "/" + id);
        };
        _this.toNewItem = function () {
            _this.props.history.push(AppRoutes.volumePromotion.path + "/" + _this.volumePromotionId + AppRoutes.volumePromotionLevel.path);
        };
        _this.toParentVolumePromotion = function () {
            _this.props.history.push(AppRoutes.volumePromotion.path + "/" + _this.volumePromotionId);
        };
        return _this;
    }
    VolumePromotions.prototype.componentDidMount = function () {
        this.volumePromotionId = _.get(this.props, 'match.params.id', '-1');
        this.getLevels();
    };
    VolumePromotions.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041D\u0438\u0432\u0430 \u043D\u0430 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("div", null,
                                React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewItem, type: "button" },
                                    React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                    " \u041D\u043E\u0432 \u0415\u043B\u0435\u043C\u0435\u043D\u0442")),
                            React.createElement("a", { onClick: this.toParentVolumePromotion },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(VolumePromotionLevelsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem, editItem: this.editItem }))))));
    };
    return VolumePromotions;
}(React.Component));
export default connect(null, SlidesReduxProps.mapDispatchToProps)(VolumePromotions);



//////////////////
// WEBPACK FOOTER
// ./src/views/VolumePromotions/VolumePromotionLevels.tsx
// module id = 516
// module chunks = 0